import { useState, useEffect } from "react";
import axios from "axios";
// import PnL from "./PnL";

import {
  Container,
  Typography,
  Button,
  Grid,
  Paper,
  Chip,
  Box
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import api from "./api";
import { BASE_URL } from './config';
import StrategyDropdown from "./StrategyDropdown";
import Time from "./Time";
function Dashboard({ onLogout }) {
  const [status, setStatus] = useState("STOPPED");
    const [strategyMode, setStrategyMode] = useState("ALL");
  // const [logs, setLogs] = useState([]);
  const startAlgo = async () => {
    await api.post(`${BASE_URL}/start`, { strategyMode });
    setStatus("RUNNING");
  };

  const stopAlgo = async () => {
    await api.get(`${BASE_URL}/stop`);
    setStatus("STOPPED");
  };

  const getStatus = async () => {
    const res = await api.get(`${BASE_URL}/status`);
    setStatus(res.data.running ? "RUNNING" : "STOPPED");
  };
//  const getLogs = async () => {
//   const res = await api.get(`${BASE_URL}/api/logs?lines=50`);
//   setLogs(res.data.logs);
// };

  useEffect(() => {
     // Initial call
     getStatus();
 // Interval refresh
  const interval = setInterval(() => {
    getStatus();
  //  getLogs();
  }, 5000);

  return () => clearInterval(interval);
  }, []);

  const exitAll = async () => {
    const confirmExit = window.confirm("Exit all trades?");
    if (!confirmExit) return;

    await axios.post(`${BASE_URL}/exit-all`);
  };
const logout = () => {
  localStorage.removeItem("token");
  onLogout(); // notify App.js
};
// console.log("logs",logs);
  return (
    <Box>
   
      {/* 🔥 HEADER */}
    <Box
  sx={{
    position: "sticky",
    top: 0,
    zIndex: 1000,
    background: "#fff",
    borderBottom: "1px solid #ddd",
    px: { xs: 2, md: 3 },   // responsive padding
    py: 1.5
  }}
>
  <Grid
    container
    alignItems="center"
    justifyContent="space-between"
    wrap="nowrap"   // 🔥 prevent breaking
  >

    {/* LEFT SIDE */}
    <Grid item xs="auto">
      <Box
        display="flex"
        alignItems="center"
        gap={{ xs: 1, md: 2 }}   // 🔥 responsive gap
      >
       <Typography
  variant="h6"
  sx={{ display: "flex", alignItems: "center" }}
>
  <img
    src="scalpxedge1.png"   // 👈 put your image in public folder
    alt="ScalpxEdge"
    style={{
      height: "100%",
      width: "240px",
      objectFit: "contain"
    }}
     
  />
</Typography>
      </Box>
    </Grid>

    {/* RIGHT SIDE */}
    <Grid item xs="auto">
      <Button
        variant="outlined"
        size="small"
        startIcon={<LogoutIcon />}
        sx={{
          fontSize: { xs: "10px", md: "14px" },   // 🔥 mobile size
          px: { xs: 1, md: 2 }
        }}
        onClick={logout}
      >
        Logout
      </Button>
    </Grid>

  </Grid>
</Box>
<Time/>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          mt: 2,
          mb: 3
        }}
      >
        <Box sx={{ width: 280 }}>
          <StrategyDropdown strategyMode={strategyMode} setStrategyMode={setStrategyMode} />
        </Box>
      </Box>

      {/* 🔥 ACTION BUTTONS (separate row) */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 2,
          flexWrap: "wrap",
          mt: 2,
          mb: 3
        }}
      >
        <Button variant="contained" color="success" onClick={startAlgo}>
          ▶ START
        </Button>

        <Button variant="contained" color="warning" onClick={stopAlgo}>
          ⏹ STOP
        </Button>

        <Button variant="outlined" onClick={getStatus}>
          🔄 REFRESH
        </Button>

        <Button variant="contained" color="error" onClick={exitAll}>
          🚨 EXIT ALL
        </Button>
         <Chip
         style={{marginTop:"7px"}}
          label={status}
          size="small"
          color={status === "RUNNING" ? "success" : "error"}
        />
      </Box>

      {/* 🔥 MAIN CONTENT */}
      <Container maxWidth={false}  sx={{ mb: 10 }}>

        <Grid container spacing={3} >

          {/* 📈 CHART */}
          <Grid item  size={{ xs: 12, sm: 12, md: 3 }}>
            <Paper sx={{ p: 2, borderRadius: 3 }}>
              <Typography variant="h6" mb={2}>
                📈 Market Chart
              </Typography>

              <Box sx={{ height: 146 }}>
                {/* Chart here */}
              </Box>
            </Paper>
          </Grid>

          {/* 📊 PnL */}
          <Grid item size={{ xs: 12, sm: 12, md: 9 }}>
            {/* <PnL status={status} /> */}
          </Grid>

        </Grid>

      </Container>

    </Box>
  );
}

export default Dashboard;